const basePath = '/reports';

export class ReportPath {
  static index() {
    return basePath;
  }
}
